(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/api/jupiter/fractiongames/pay.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/api/jupiter/fractiongames/pay.js');

'use strict';

class PayFractionGame extends svs.tur.payment.api.jupiter.base.PayBase {
  constructor(_ref) {
    let {
      productName,
      productNumeric,
      price,
      drawId,
      sharesTotal,
      containerId
    } = _ref;
    const payableObj = {
      productName,
      price,
      drawId
    };
    const drawgamesApiCaller = svs.tur.apiCaller.drawgames;
    const apiCallerFunction = _ref2 => {
      let {
        onSuccess,
        onError
      } = _ref2;
      return drawgamesApiCaller.postMarketplaceActivatedDrawsSoldSharesByDrawId({
        drawId,
        successCB: onSuccess,
        errorCB: onError
      });
    };
    super({
      wagerModel: payableObj,
      apiCallerFunction
    });
    this.productName = productName;
    this.productNumeric = productNumeric;
    this.price = price;
    this.sharesTotal = sharesTotal;
    this.payableObj = payableObj;
    this.draws = svs.numbergames.draws.drawsApi;
    this.isAutoPayAfterDeposit = svs.core.detect.feature('ft-fractiongames-pay-after-deposit');
    this.isAfterPayAndAutoPay = svs.core.detect.feature('ft-fractiongames-pay-after-deposit') && svs.utils.paramHandler.get({
      key: 'afterpay'
    }).value;
    this.returnParams = {
      containerId
    };
  }
  onAccountStatusSuccess() {
    if (this.shouldShowPlayingNextDrawDialog()) {
      this.showPlayingNextDrawDialog({
        onConfirm: () => {
          super.onAccountStatusSuccess();
        }
      });
    } else {
      super.onAccountStatusSuccess();
    }
  }
  shouldShowPlayingNextDrawDialog() {
    return this.draws.wasOpenedToday(this.productNumeric);
  }
  showPlayingNextDrawDialog(_ref3) {
    let {
      onConfirm
    } = _ref3;
    new svs.tur.payment.dialogs.PlayingNextDraw({
      productNumeric: this.productNumeric,
      regCloseTime: this.draws.currentRegCloseTime(this.productNumeric),
      onCancel: () => {
        this.destroy();
      },
      onConfirm
    });
  }
  showConfirmDialog() {
    if (svs.core.detect.feature('ft-fractiongames-pay-after-deposit') && svs.utils.paramHandler.get({
      key: 'afterpay'
    }).value) {
      svs.utils.paramHandler.remove({
        key: 'afterpay'
      });
      this.sendPayment();
      return;
    }
    new svs.tur.payment.api.jupiter.fractiongames.dialogs.PaymentConfirm({
      price: this.price,
      productName: this.productName,
      productNumeric: this.productNumeric,
      accountBalance: this.account.balance,
      isCancalable: false,
      onCancel: () => {
        this.destroy();
      },
      onConfirm: () => {
        this.sendPayment();
      }
    });
  }
  showSuccessDialog() {
    svs.components.account_balance.get(true, balance => {
      new svs.tur.payment.api.jupiter.fractiongames.dialogs.PaymentSuccess({
        isAfterPayAndAutoPay: this.isAfterPayAndAutoPay,
        productName: this.productName,
        productNumeric: this.productNumeric,
        accountBalance: balance,
        onConfirm: () => {
          new svs.tur.CorrectionEmail({
            productName: svs.numbergames.productMapping.getProductName(this.productName),
            callback: () => {
              this.onSuccessDialogConfirm();
            }
          }).show();
        }
      });
    });
  }
  sendAnalytics() {
    svs.components.analytics.trackEvent({
      category: 'Andelsspel',
      action: "".concat(this.sharesTotal, " Andelsspel"),
      opt_label: this.productName,
      opt_value: parseInt(this.price, 10)
    });
  }
}
svs.tur.payment.api.jupiter.fractiongames.Pay = PayFractionGame;

 })(window);